export default "/arETH.1ad16849b1346d92dfffebee369cfcc0.png";